import axios from 'axios';

/**
 * Fetch devices from API with Bearer token
 * @param {string} token - Bearer token for authorization
 * @returns {Promise} - Promise representing the response data
 */
export const fetchDevices = async (token) => {
  try {
    const response = await axios.get(process.env.REACT_APP_BASE_API_URL+'/categories');
    return response.data; // or response if you need the whole response
  } catch (error) {
    console.error("Error fetching devices:", error);
    throw error;
  }
};

export const fetchBrands = async (id) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BASE_API_URL+`/brands/${id}`);
      return response.data; // or response if you need the whole response
    } catch (error) {
      console.error("Error fetching devices:", error);
      throw error;
    }
  };

export const fetchModels = async (catId, id) => {
    try {
      const response = await axios.get(process.env.REACT_APP_BASE_API_URL+`/devices/${catId}/${id}`);
      return response.data; // or response if you need the whole response
    } catch (error) {
      console.error("Error fetching devices:", error);
      throw error;
    }
  };

  export const fetchDefects = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_BASE_API_URL+'/defects');
      return response.data; // or response if you need the whole response
    } catch (error) {
      console.error("Error fetching devices:", error);
      throw error;
    }
  };


  export const CreateLead = async (DataTable, token) => {
    try {
        console.log('DataTable', DataTable)
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_API_URL}/create-lead`,
          JSON.stringify(DataTable), // This is the data payload you're sending to the server
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );
    
        // Return the response data from the server
        return response.data;
      } catch (error) {
        if (error.response) {
          // Error from server response
          throw new Error(error.response.data.message || 'Submitting defects failed');
        } else if (error.request) {
          // Error related to the network request, but no response received
          throw new Error('Network error: No response received');
        } else {
          // Other unexpected errors
          throw new Error('An unexpected error occurred');
        }
      }
};




